import React from "react";
import { Outlet, /* useNavigate */ } from "react-router-dom";
import ResponsiveSideBar from "../components/SideBar/ResponsiveSideBar";

const MainRoutes = () => {
  /* const userRole = sessionStorage.getItem("userRole");
  const navigate = useNavigate(); */

  /* useEffect(() => {
    if (userRole === "2") {
      navigate("/homeAlumno");
    }
    else if(userRole !== "1"){
        navigate("/");
    }
  }, [userRole, navigate]); */

  return (
      <ResponsiveSideBar>
          <Outlet/>
      </ResponsiveSideBar>
  )
};

export default MainRoutes;